import { getRegisterFunction } from '../../utils/register.js';
import { OneUxBadgeElement } from './OneUxBadgeElement.js';
export const register = getRegisterFunction(OneUxBadgeElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-badge': OneUxBadgeElement;
    "badge-b5245e42a8e7407eea8dbf0178262988": OneUxBadgeElement;
  }
}